/**
 * A text with its name tags drawn (docs/mentions.md, flag `mentionsUI`; owner, 2026-10-19: "it
 * should have some sort of colored highlighting or something that's consistent with that user"):
 * each household name in it a small pill in that peon's colour (shared/mentions.ts mentionColours),
 * the name in the tag's ink, a two-pixel underline in the peon's own colour. Only the words: it
 * draws inside whatever element the caller already has, so fonts, sizes, clamps and frames stay
 * the caller's. With the flag off, or the names not read yet, the plain text, exactly as before.
 */
import "./mentions.css";
import { useMentionRoster, type MentionRoster } from "../mentions";
import { mentionSpans } from "../../shared/mentions.ts";

/** The runs of `text` as nodes, tagged names as pills; the plain text when there is no roster. */
export function mentionNodes(text: string, roster: MentionRoster | null) {
  if (!roster || !text) return text;
  const spans = mentionSpans(text, roster.names);
  if (!spans.some((s) => s.name)) return text;
  return spans.map((s, i) => {
    if (!s.name) return s.text;
    const c = roster.colourOf(s.name);
    return (
      <span key={i} class="mention" data-mention={s.name} style={{ "--mention-tint": c.tint, "--mention-swatch": c.swatch, "--mention-ink": c.ink }}>
        {s.text}
      </span>
    );
  });
}

export function MentionText({ text }: { text: string }) {
  const roster = useMentionRoster();
  return <>{mentionNodes(text, roster)}</>;
}
